module.exports = __webpack_public_path__ + "img/Waldspaziergang.89cf7363.jpg";